// extracted by mini-css-extract-plugin
module.exports = {"sizeText":"oneProduct_sizeText__2ONMb","sizeToastify":"oneProduct_sizeToastify__3gGpM"};